export default "__VITE_PUBLIC_ASSET__f96542a6__"